/* eslint-disable */
import axios, { AxiosError, AxiosResponse } from "axios";
import { CreateCompletionRequest, CreateCompletionResponse } from "./openai-api";
import { csContext } from "../../services/cs-context";
import d from "debug";

const debug = d("cs.smartSearch");

interface completeOptions {
  maxTokens?: number;
}

const splitRegex: () => RegExp = () =>
  /^ *[•\-*] *|^ *d+[.:)]|^ *[A-Za-z][.:)]|\n[A-Za-z][.:)] *|\n\d+[.:)] *|\n[•\-*] */gi;

export { splitRegex };

const models = {
  1: "text-ada-001",
  2: "text-babbage-001",
  3: "text-curie-001",
  4: "text-davinci-003",
  chatGpt: "gpt-3.5-turbo",
};

export { models };

const logit_bias = {};
logit_bias[90] = -100; // "{"
logit_bias[1391] = -100; // " {"
logit_bias[92] = -100; // "}"
logit_bias[1782] = -100; // " }"

export const tokens = {
  "{": 90,
  " {": 1391,
  "}": 92,
  " }": 1782,
  "\n": 198,
  "\n\n": 628,
  ":": 25,
  " :": 1058,
  "[": 58,
  " [": 685,
  '"': 1,
  ' "': 366,
  "<|endoftext|>": 50256,
  " read": 1100,
  "____": 1427,
  "_____": 29343,
  ".": 13,
  " 1": 352,
  " 2": 362,
  " 3": 513,
  " 4": 604,
  " 5": 642,
  " 6": 718,
  " 7": 767,
  " 8": 807,
  " 9": 860,
  " 10": 838,
  " 11": 1367,
  " 12": 1105,
  "No": 2949,
  "Yes": 5297,
  " of": 286,
  " -": 532,
  " it": 340,
  " this": 428,
  " that": 326,
  " difficult": 2408,
  ",": 11,
  " and": 290,
  ";": 26,
  "/": 14,
  " /": 1220,
  " how": 703,
  " essential": 6393,
  " any": 597,
  " success": 1943,
  " an": 281,
  " important": 1593,
  " successful": 4388,
  "Application": 23416,
  " To": 1675,
  "To": 2514,
  "How": 2437,
  " This": 770,
  " These": 2312,
  " these": 777,
  " It": 632,
  " By": 2750,
  " Additionally": 12032,
  " Also": 4418,
  " also": 635,
  "Edited": 45882,
  " encourages": 18656,
  " Personal": 15644,
  " Team": 4816,
  " Leadership": 26935,
  " personal": 2614,
  " team": 1074,
  " leadership": 5531,
  " the": 262,
  "As": 1722,
  " As": 1081,
  "AI": 20185,
  " AI": 9552,
};

const defaultOptions = () =>
  ({
    model: models[4],
    max_tokens: 150,
    temperature: 0,
    top_p: 1,
    presence_penalty: 0,
    frequency_penalty: 0,
    logit_bias,
    user: process.env.VUE_APP_MODE === "development" ? "system" : csContext?.user?.id ?? "system",
  } as CreateCompletionRequest & {
    token_bias?: Partial<typeof tokens>;
  });

const timer4 = null as null | Promise<any>;
const timer3 = null as null | Promise<any>;

type CompleteOptions = Partial<CreateCompletionRequest> & {
  token_bias?: Partial<typeof tokens>;
} & { prompt: string };

const completeWithInfo = async (optionsArray: CompleteOptions[]) => {
  debug(
    "Running:",
    optionsArray.map((o) => o.prompt),
  );

  let optionsCombinedArray = optionsArray.map((options) => {
    const start = Date.now();

    const optionsCombined = defaultOptions();
    for (const k of Object.keys(options)) {
      optionsCombined[k] = options[k];
    }

    optionsCombined.logit_bias = JSON.parse(JSON.stringify(optionsCombined.logit_bias ?? {}));
    for (const token of Object.keys(options.token_bias ?? {})) {
      optionsCombined.logit_bias![tokens[token]] = options.token_bias![token];
    }

    optionsCombined.token_bias = undefined;

    optionsCombined.prompt = options.prompt.replace("|>|", "");
    return optionsCombined;
  });

  // let result2: CreateCompletionResponse = await openai.createCompletion(optionsCombined, {
  //   /* timeout: 9000 */
  // });
  let results = [] as CreateCompletionResponse[];

  await axios.post("/api/openaicompletions", optionsCombinedArray).then((resp) => {
    results = resp.data;
  });

  let returns = results.map((data, i) => {
    //   window._openAiUsage = window._openAiUsage || {};
    //   window._openAiUsage[optionsCombined.model ?? models[4]] =
    //     (window._openAiUsage[optionsCombined.model ?? models[4]] || 0) + data.usage?.total_tokens ?? 0;
    //   window._openAiUsage.dollars =
    //     (window._openAiUsage[models[4]] || 0) * (0.02 / 1000) +
    //     (window._openAiUsage[models[3]] || 0) * (0.002 / 1000);

    const completion = data.choices.map((x) => x.text!);

    if (optionsCombinedArray[i].max_tokens === 1 && data!.choices[0].logprobs?.top_logprobs) {
      debug(
        optionsCombinedArray[i].prompt + completion[i],
        (data!.choices[0].logprobs?.top_logprobs ?? {})[0],
      );
    } else {
      debug(optionsCombinedArray[i].prompt + completion[i]);
    }
    const repeat = optionsArray[i].prompt.split("|>|")[1] ?? "";
    const output = repeat + completion[i];

    var ret = { output, result: data, prompt: optionsArray[i], completion };
    return ret;
  });

  return returns;
};

const complete = async (prompt: string, options?: Partial<CompleteOptions>) => {
  options = options || {};
  options.prompt = prompt;
  return (await completeWithInfo([options as CompleteOptions]))[0].output;
};

window["complete"] = (prompt: string) => complete(prompt);

export { complete, completeWithInfo };
